import { StickySectionFilter } from 'styles/styled-components/section';
import style from 'styles/styled-components/style';

import OrdinalFilter from './filter/OrdinalFilter';

// platform : all+platform(instagram, youtube) or only platform
// cardinal & mission & special : only cardinal or cardianl+mission or cardinal+mission+special
// option : include special or include advertise
// chips : all+cardinal (중복선택 가능)

const FilterRow = () => {
	return (
		<StickySectionFilter _padding="16px">
			<Grid flex="between">
				<Grid _width="max-content" flex="start" _gap="16px">
					<OrdinalFilter />
				</Grid>
			</Grid>
		</StickySectionFilter>
	);
};

const { Grid } = style;

export default FilterRow;
